<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Ad Group {{query_text?'for '+ query_text : ''}}</h5>
          </div>
          <div class="modal-body main_form_block">
            <div
              v-if="showAddRecommendedLoader"
              class="spinner-border"
              style="margin-left: 50%"
            ></div>

            <div class="row" style="padding-top: 10px" v-else>
              <label class="col-md-3" style="padding-top: 10px">Ad Group</label>
              <!-- <multiselect
											v-model="keywordCampGrp"
											:options="keywordCampGrpList"
											@search-change="searchFromDb"
											:searchable="true"
											ref="multiselect"
											label="title"
											:track-by="id"
											open-direction="bottom"
											:taggable="false"
											placeholder="Search..."
											class="form-control multi-dropdown col-md-4"
											selectLabel
											deselectLabel
											selectedLabel
											style="margin-left:15px"
											:disabled="showAddGroup"
										>
							</multiselect>-->
              <multiselect
                v-model="keywordGrp"
                :options="keywordGrpList"
                :searchable="true"
                ref="multiselect"
                :loading="loadingAddGroup"
                label="title"
                track-by="title"
                @tag="addKeywordGroup"
                open-direction="bottom"
                :taggable="true"
                placeholder="Search..."
                class="form-control multi-dropdown col-md-4 select_filter"
                selectLabel=''
                deselectLabel=''
                selectedLabel=''
                autocomplete="off"
                style="margin-left: 15px; max-height: 40px"
                :multiple="true"
                @input="resetKeywordGrp"
                :class="{ 'is-invalid': submitted && !keywordGrp }"
                id="keywordGrp"
              >
                <template slot="noResult">
                  <div>Oops! No Element Found</div>
                </template>
                <template slot="option" slot-scope="props">
                  <div
                    v-bind:class="
                      props.option.ams_ad_group_id
                        ? 'option__desc'
                        : 'option_noID'
                    "
                  >
                    <span class="option__title">{{ props.option.title }}</span>
                  </div>
                </template>
              </multiselect>
              <span
                v-if="submitted && !keywordGrp"
                style="margin-left: 27%"
                class="invalid-feedback"
                >Select keyword group
              </span>
              <!-- <div class = "col-md-1">
											<button class="btn btn-primary" @click = "addNewGroup">
												<i class="fa fa-plus"></i>
											</button>
							</div>-->
              <!-- To show total number of keywords that can be added in a grp -->
              <!-- <div class="col-md-4" v-if="keywordGrp && keywordGrp.count">
								<span style="color:red">You cannot add more than {{ 1000 - keywordGrp.count }} keywords in a group.</span>
							</div> -->
              <div
                class="col-md-4"
                v-if="
                  Object.keys(keywordGrp).length &&
                  keywordGrp &&
                  keywordGrp.count == '1000'
                "
              >
                <span style="color: red"
                  >You cannot add more than 1000 keywords in a group.</span
                >
              </div>
            </div>
            <div
              v-if="
                !showAddRecommendedLoader &&
                keywordGrp &&
                !keywordGrp.ams_ad_group_id
              "
              class="row"
              style="padding-top: 20px"
            >
              <label for="groupBid" class="col-sm-3 col-form-label"
                >Group Bid</label
              >
              <div class="col-sm-4" style="margin-left: 15px; padding: 0px">
                <input
                  type="text"
                  :class="{ 'is-invalid': submitted && !groupBid }"
                  placeholder="Enter group bid"
                  v-model="groupBid"
                  class="form-control"
                  id="groupBid"
                />
                <span v-if="submitted && !groupBid" class="invalid-feedback"
                  >Enter bid amount to proceed</span
                >
              </div>
            </div>
            <!-- <div class ="row" style="padding-top:20px" v-if = "showAddGroup">
							<div class = "col-md-3"></div>
							<div class = "col-md-4">
								<input
									style="height:93%;width:100%"
									type="text"
									placeholder="Enter New Group Name"
									v-model="newGroupName"
									required="true"
									class="form-control"
									autocomplete="off"
									id="value"
								>
							</div>
							<div>
								<button type="button" class="btn btn-primary" @click = "cancelAddingNewGroup">Cancsel</button>
								<div v-if="showAddNewLoader" class="spinner-border" ></div>
								<button v-else type="button" class="btn btn-primary" @click = "saveNewKeyWordGroup">Save</button>
							</div>
						</div>-->
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="hideModal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="addKeyordToGroup"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>


<script>
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  name: "AddKeywordGroupModal",
  data() {
    return {
      keywordGrpList: [],
      keywordGrp: "",
      showAddGroup: false,
      newGroupName: "",
      showAddNewLoader: false,
      showAddRecommendedLoader: false,
      groupBid: "",
      id: "",
      submitted: false,
      loadingAddGroup: false,
    };
  },
  components: {
    Multiselect,
    moment,
  },
  props: {
    ams_campaign_id: String,
    local_campaign_id: String,
    recommended_id: Number,
    ams_profile_id: String,
    campaign_type: String,
    campaignObj: Object,
	cost:Number,
	match_type:String,
	currentPage:String,
	keyword_text:String,
  query_text:String,
  ams_keyword_id:String
  },
  mounted() {
    $("#keywordGrp").attr("autocomplete", "off");
    this.getGroupList();
    // this.showAddRecommendedLoader = true
    // let payload = {
    // 		"ams_campaign_id":this.ams_campaign_id
    // }
    // this.$store.dispatch("campaign/getKeywordGroupList", payload).then((res) => {
    // 	this.keywordGrpList = res
    // 	this.showAddRecommendedLoader = false
    // })
  },
  watch: {
    keywordGrp() {
      this.groupBid = "";
    },
  },
  methods: {
    addKeywordGroup(name) {
      this.keywordGrp = "";
      var pay = { title: name };
      this.keywordGrpList.push(pay);
      this.keywordGrp = pay;
    },
    resetKeywordGrp(option) {
      if (option.length) {
        this.keywordGrp = option[option.length - 1];
      } else {
        this.keywordGrp = "";
      }
    },
    hideModal() {
      this.$emit("hideKeywordGroupModal", false);
    },
    // addNewGroup(){
    // 	this.keywordGrp = {}
    // 	this.showAddGroup = true
    // },
    // cancelAddingNewGroup(){
    // 	this.showAddGroup = false;
    // 	this.newGroupName = ""
    // },
    // saveNewKeyWordGroup(){
    // 	 ;
    // 	this.showAddNewLoader = true;
    // 	let vm = this;
    // 	let payload = {
    // 		ams_campaign_id: this.ams_campaign_id,
    // 		local_campaign_id: this.local_campaign_id,
    // 		title:this.newGroupName,
    // 	}
    // 	this.$store.dispatch('campaign/saveNewKeyWordGroup', payload).then((res) => {
    // 		vm.showAddNewLoader = false;
    // 		vm.keywordGrpList.push(res);
    // 		vm.keywordGrp = res;
    // 		vm.showAddGroup = false;
    // 		vm.newGroupName = ""
    // 	})
    // },
    validate() {
      this.submitted = true;
      if (
        this.keywordGrp &&
        this.keywordGrp.title &&
        this.keywordGrp.ams_ad_group_id
      ) {
        this.submitted = false;
        return true;
      }
      if (
        this.keywordGrp &&
        this.keywordGrp.title &&
        !this.keywordGrp.ams_ad_group_id &&
        this.groupBid
      ) {
        this.submitted = false;
        return true;
      } else {
        $("groupBid").focus();
        $("keywordGrp").focus();
      }
    },
    addKeyordToGroup() {
      if (this.validate()) {
        this.showAddRecommendedLoader = true;
        let vm = this;
        if (this.currentPage == "exact") {

          let payload = {
            "ams_campaign_id": this.ams_campaign_id,
            "id": this.recommended_id,
            "group_id": this.keywordGrp ? this.keywordGrp.ams_ad_group_id : "",
            "count": this.keywordGrp && this.keywordGrp.ams_ad_group_id
                    ? this.keywordGrp && this.keywordGrp.count
                      ? this.keywordGrp.count
                      : "0"
                    : "0",
            "title": this.keywordGrp.title,
            "campaign_id": this.local_campaign_id,
            "userName": JSON.parse(window.localStorage.session).name,
            "ams_profile_id": this.ams_profile_id,
            "campaign_type": this.campaign_type,
            "targeting_type": this.campaignObj.targeting_type,
            "daily_budget": this.campaignObj.daily_budget,
            "start_date_ams": moment(this.campaignObj.start_date).format(
                  "YYYYDDMM"
                ),
            "campaign_name":this.campaignObj.name,
            "grpBid": this.keywordGrp.id ? this.keywordGrp.bid : this.groupBid,
            "ams_ad_group_id": this.keywordGrp.ams_ad_group_id
                  ? this.keywordGrp.ams_ad_group_id
                  : "",
            "cost":this.cost,
            "match_type":'Exact'||this.match_type,
            "tableType":this.campaign_type=='sponsoredBrands'?'sb':'sp',
            "keyword_text":this.query_text||'',
            "ams_keyword_id":this.ams_keyword_id||''
          }
          this.$store
                .dispatch("campaign/addExactKeyword", payload)
                .then((res) => {
                  vm.showAddRecommendedLoader = false;
                  vm.$emit("hideKeywordGroupModal", false, true,'Exact');
                });

            } 
        else {
          let payload = {
            ams_campaign_id: this.ams_campaign_id,
            type: "Processed",
            recommended_id: this.recommended_id,
            group_id: this.keywordGrp ? this.keywordGrp.ams_ad_group_id : "",
            count:
              this.keywordGrp && this.keywordGrp.ams_ad_group_id
                ? this.keywordGrp && this.keywordGrp.count
                  ? this.keywordGrp.count
                  : "0"
                : "0",
            title: this.keywordGrp.title,
            campaign_id: this.local_campaign_id,
            userName: JSON.parse(window.localStorage.session).name,
            ams_profile_id: this.ams_profile_id,
            campaign_type: this.campaign_type,
            targeting_type: this.campaignObj.targeting_type,
            daily_budget: this.campaignObj.daily_budget,
            start_date_ams: moment(this.campaignObj.start_date).format(
              "YYYYDDMM"
            ),
            campaign_name: this.campaignObj.name,
            grpBid: this.keywordGrp.id ? this.keywordGrp.bid : this.groupBid,
            ams_ad_group_id: this.keywordGrp.ams_ad_group_id
              ? this.keywordGrp.ams_ad_group_id
              : "",
          };
          this.$store
            .dispatch("campaign/addRecommendedKeyword", payload)
            .then((res) => {
              vm.showAddRecommendedLoader = false;
              vm.$emit("hideKeywordGroupModal", false, true);
            });
        }
      } else {
        return;
      }
    },
    getGroupList() {
      this.showAddRecommendedLoader = true;
      let payload = {
        type: this.campaign_type,
        ams_campaign_id: this.ams_campaign_id,
      };
      this.$store
        .dispatch("campaign/getKeywordGroupList", payload)
        .then((res) => {
          this.keywordGrpList = res;
          this.showAddRecommendedLoader = false;
        });
    },
    searchFromDb(searchText) {
      if (searchText != "") {
        let payload = {
          type: this.campaign_type,
          ams_campaign_id: this.ams_campaign_id,
          q: searchText,
        };
        this.loadingAddGroup = true;
        this.$store
          .dispatch("campaign/getKeywordGroupList", payload)
          .then((res) => {
            this.loadingAddGroup = false;
            this.keywordGrpList = res;
            //	this.showAddRecommendedLoader = false
          });
      }
    },
  },
};
</script>

<style lang="scss">
</style>
